module.exports = __webpack_public_path__ + "static/img/sessao-expirada.d12960be.svg";